import PremiumBanner from "@/components/PremiumFeatureComponents/PremiumBanner";
import { Popover } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import React from "react";
import styles from "./PremiumFeatures.module.scss";

function PremiumBannerTooltip({
  show = true,
  placement = "bottom",
  children,
}: {
  show?: boolean;
  placement?: TooltipPlacement;
  children: React.ReactNode;
}) {
  return (
    <Popover
      placement={placement}
      classNames={{ body: styles.premiumPopoverContent, root: styles.premiumPopoverRoot }}
      content={show ? <PremiumBanner /> : null}
    >
      <>{children}</>
    </Popover>
  );
}

export default PremiumBannerTooltip;
